import React, {Component} from 'react'
import PrintPreview from '../PrintPreview'
import PdfStore from '../../../stores/PdfStore'
import './Print.css'

var NotificationSystem = require('react-notification-system');
const DEFAUT_ROW = 19
class PrintSSRGeneralDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false,data:{itemlist:this.newEmptyRow(DEFAUT_ROW)},page_title:'กำลังดึงข้อมูล..',defaultTypePrint:'3',dataList:[]}
    
    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem
    this.loadData()
  }

  newEmptyRow(number){
  	let emptyRow = {}
  	if (this.props.doc==='invoice_doc')
  		emptyRow = {amount:'',bf_invoice_item_id:'',detail:'',discount:'',invoice_no:'',price_per_unit:'',quantity:'',seq:''}
  	else if (this.props.doc==='taxinvoice_doc')
  		emptyRow = {amount:'',bf_taxinvoice_item_id:'',detail:'',discount:'',taxinvoice_no:'',price_per_unit:'',quantity:'',seq:''}

    return new Array(number).fill(null).map((item,index)=>{
      return emptyRow
    })
  }

  loadData() {
  	let {data} = this.state
  	this.setState({loading:true})
 	PdfStore.loadBNPDoc(this.props.doc,this.props.param,this.props.docNo,(result)=>{
        data = result.data
 		if (data.itemlist!==undefined&&data.itemlist.length>0) {
            if (data.itemlist.length<13)
                data.itemlist = data.itemlist.concat(this.newEmptyRow(13-data.itemlist.length))
        }
 		this.setState({loading:true,data:data,dataList:this.getPagination(data.itemlist)})
 	})
  }

  renderLogoUrl(logoUrl){
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    if(logoUrl!==undefined)
      return (<img src={imgUrl} />)
    else
      return ('')
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getSummaryDiscount() {
  	let {data} = this.state
  	let sum = 0
  	data.itemlist.forEach(function(item,index) {
  		let discount = item.discount
  		if (discount===''||discount===null||discount===undefined||isNaN(discount))
  			discount = 0

  		sum += parseFloat(discount)
  	})
  	return sum
  }

  getSummaryAmount() {
  	let {data} = this.state
  	let sum = 0
  	data.itemlist.forEach(function(item,index) {
  		let amount = item.amount
  		if (amount===''||amount===null||amount===undefined||isNaN(amount))
  			amount = 0
  		
  		sum += parseFloat(amount)
  	})
  	sum = sum - this.getSummaryDiscount()
  	return sum
  }

  getVat() {
  	let {data} = this.state
  	let sum = 0
  	if (data.vat_type==='VAT_EXCLUDE') {
  		sum = (this.getSummaryAmount()*7)/100
  		return sum
  	} else {
  		return sum
  	}
  }

  getDiscountPercent(discount=0,amount=0) {
  	let sum = (discount*100)/amount
  	return sum
  }

  renderSignature() {
    let {data} = this.state
    return(
      <div>    
        <table className='table table-ssr-general-doc'>
	        <tbody>
	          <tr>
	          	<td className='br-h' style={{width:'33.33%',borderBottomLeftRadius:'8px'}}>
                    <br/>
                    <div style={{width:'100%'}}>
                        <div style={{width:'20%',display:'inline-block'}}>ผู้ส่งของ</div>
                        <div style={{width:'80%',display:'inline-block',borderBottom:'1px solid #111'}}></div>
                    </div>    
                    <br/>
                    <div style={{width:'100%'}}>
                        <div style={{width:'20%',display:'inline-block'}}>ผู้ตรวจ</div>
                        <div style={{width:'80%',display:'inline-block',borderBottom:'1px solid #111'}}></div>
                    </div>
	          	</td>
                <td className='br-h' style={{width:'33.33%'}}>
                    <br/>
                    <div style={{width:'100%'}}>
                        <div style={{width:'20%',display:'inline-block'}}>ผู้รับเงิน</div>
                        <div style={{width:'80%',display:'inline-block',borderBottom:'1px solid #111'}}></div>
                    </div>    
                    <br/>
                    <div style={{width:'100%'}}>
                        <div style={{width:'20%',display:'inline-block'}}>ผู้ขาย</div>
                        <div style={{width:'80%',display:'inline-block',borderBottom:'1px solid #111'}}></div>
                    </div>
	          	</td>
                <td className='' style={{width:'33.33%'}}>
                    ในนาม 
                    <br/>
                    For
	          	</td>
	          </tr>
              <tr>
	          	<td colSpan={2} className='bl-h bt-h br-h bb-h text-center'>
                    <br/>
                    ได้รับของตามรายการข้างบนนี้ถูกต้องเรียบร้อยแล้ว
                    <br/>
                    Received goods stated above in good order & conditions
                    <div style={{width:'100%',marginTop:'10px'}}>
                        <div style={{width:'15%',display:'inline-block'}}>ลงชื่อ SIGNED</div>
                        <div style={{width:'35%',display:'inline-block',borderBottom:'1px solid #111'}}></div>
                        <div style={{width:'15%',display:'inline-block'}}>วันที่ DATE</div>
                        <div style={{width:'35%',display:'inline-block',borderBottom:'1px solid #111'}}></div>
                    </div>
	          	</td>
                <td className='bt-h' style={{verticalAlign:'middle',borderBottomLeftRadius:'8px'}}>
                    ใบส่งสินค้าทุกฉบับ จะต้องชำระเงินภายในกำหนดดังกล่าวข้างต้น มิฉะนั้น จะต้องเสียดอกเบี้ยในอัตราสูงสุดตามที่กฎหมายระบุไว้ เมื่อจ่ายเงินโปรดเรียกใบเสร็จรับเงินจากบริษัทฯ
	          	</td>
	          </tr>
	        </tbody>
	    </table>   
      </div>       
    )
  }

  renderBody(itemlist,itemIndex) {
    let {data} = this.state
    return(
      <div>
          <table className='table table-ssr-general-doc'>
            <tbody>
                <tr>
                    <td style={{width:'300px'}} className='text-center br-h'>แผนก<br/>SECTION NAME<br/></td>
                    <td style={{width:'100px'}} className='text-center br-h'>ลูกค้าเลขที่<br/>CUSTOMER NO.<br/></td>
                    <td style={{width:'200px'}} className='text-center br-h'>เงื่อนไขการชำระ<br/>TERMS OF PAYMENT<br/>{data.credit_day===null||data.credit_day===undefined?'':data.credit_day+' วัน'}</td>
                    <td style={{width:'100px'}} className='text-center br-h'>เขต / ผู้ขาย<br/>AREA/SALESMAN<br/></td>
                    <td colSpan={2} className='text-center'>เอกสารเลขที่<br/>DOCUMENT NO.<br/>{data.doc_no===null||data.doc_no===undefined?'':data.doc_no}</td>
                </tr>
                <tr>
                    <td colSpan={4} className='bt-h br-h bb-h'>
                        ชื่อลูกค้า<br/>NAME {data.customer_name===null||data.customer_name===undefined?'':data.customer_name}
                    </td>
                    <td rowSpan={2} colSpan={2} className='bt-h text-center' style={{verticalAlign:'middle'}}>อ้างถึงเอกสาร REFERENCE NO.<br/></td>
                </tr> 
                <tr>
                    <td colSpan={4} className='bt-h br-h bb-h'>
                        ที่อยู่<br/>ADDRESS {data.customer_address===null||data.customer_address===undefined?'':data.customer_address}
                    </td>
                </tr> 
                <tr>
                    <td colSpan={4} className='bt-h br-h bb-h'>
                        สาขาที่ออก -<br/>ใบกำกับภาษี คือสาขา {data.customer_branch===null||data.customer_branch===undefined?'':data.customer_branch}
                    </td>
                    <td style={{width:'100px'}} className='text-center bt-h br-h'>วันที่ DATE<br/>{data.doc_date===null||data.doc_date===undefined?'':data.doc_date}</td>
                    <td style={{width:'100px'}} className='text-center bt-h'>เวลา TIME<br/></td>
                </tr>
                <tr>
                    <td colSpan={4} className='bt-h br-h'>
                        รายละเอียด<br/>DETAIL 1 ) ยี่ห้อ {data.car==undefined||data.car.brand==''||data.car.brand==null||data.car.brand==undefined?'-':data.car.brand} ทะเบียนรถ {data.car==undefined||data.car.car_registration_no==''||data.car.car_registration_no==null||data.car.car_registration_no==undefined?'-':data.car.car_registration_no} แชซซีส์ {data.car==undefined||data.car.chassis_no==''||data.car.chassis_no==null||data.car.chassis_no==undefined?'-':data.car.chassis_no} 
                        &nbsp; 2 ) รุ่นรถ {data.car==undefined||data.car.model==''||data.car.model==null||data.car.model==undefined?'-':data.car.model} สี {data.car==undefined||data.car.color==''||data.car.color==null||data.car.color==undefined?'-':data.car.color} 
                        &nbsp; 3 ) แบบรถ - เครื่องยนต์ {data.car==undefined||data.car.engine_no==''||data.car.engine_no==null||data.car.engine_no==undefined?'-':data.car.engine_no}
                    </td>
                    <td style={{width:'100px'}} className='text-center bt-h br-h'>วันที่ครบกำหนด DUE DATE<br/>{data.due_date===null||data.due_date===undefined?'':data.due_date}</td>
                    <td style={{width:'100px'}} className='text-center bt-h'>USER ID<br/></td>
                </tr>    
            </tbody>
          </table>
          {this.renderTable(itemlist,itemIndex)}
          {this.renderSignature()}
      </div>
    )
  }    

  renderTable(itemlist,itemIndex) {
    let {data} = this.state
  	return(
        <div>  
  		  <table className='table table-ssr-general-doc'>
	        <tbody>
	          <tr>
	            <td style={{width:'5%'}} className='text-center br-h bb-h'></td>
	            <td style={{width:'40%'}} className='text-center br-h bb-h'>รายการ</td>
	            <td style={{width:'10%'}} className='text-center br-h bb-h'>จำนวน<br/>QTY</td>
	            <td style={{width:'12%'}} className='text-center br-h bb-h'>ราคาขาย<br/>LIST PRICE</td>
	            <td style={{width:'10%'}} className='text-center br-h bb-h'>ส่วนลด %</td>
	            <td style={{width:'10%'}} className='text-center br-h bb-h'>ราคาหน่วยละ<br/>UNIT PRICE</td>
	            <td style={{width:'13%'}} className='text-center bb-h'>จำนวนเงิน<br/>AMOUNT</td>
	          </tr>
	          {this.renderRowData(itemlist,itemIndex)}
              <tr style={{display:(itemlist.summary.sum?'':'none')}}>
                <td className='text-center bt-h br-h bb-h'></td>
	          	<td className='bt-h br-h bb-h'>เลขที่เคลม <span style={{float:'right'}}>-</span></td>
	            <td className='bt-h br-h bb-h'></td>
                <td className='bt-h br-h bb-h text-right'></td>
                <td className='bt-h br-h bb-h text-right'></td>
                <td className='bt-h br-h bb-h text-right'></td>
	            <td className='bt-h bb-h text-right'></td>
	          </tr>
              <tr style={{display:(itemlist.summary.sum1?'':'none')}}>
                <td className='text-center bt-h br-h bb-h'></td>
	          	<td className='bt-h br-h bb-h'>เลขที่กรมธรรม์ <span style={{float:'right'}}>-</span></td>
	            <td className='bt-h br-h bb-h'></td>
                <td className='bt-h br-h bb-h text-right'></td>
                <td className='bt-h br-h bb-h text-right'></td>
                <td className='bt-h br-h bb-h text-right'></td>
	            <td className='bt-h bb-h text-right'></td>
	          </tr>
              <tr style={{display:(itemlist.summary.sum2?'':'none')}}>
                <td className='text-center bt-h br-h bb-h'></td>
	          	<td className='bt-h br-h bb-h'>ค่าแรง <span style={{float:'right'}}>0.00</span></td>
	            <td className='bt-h br-h bb-h'></td>
                <td className='bt-h br-h bb-h text-right'></td>
                <td className='bt-h br-h bb-h text-right'></td>
                <td className='bt-h br-h bb-h text-right'></td>
	            <td className='bt-h bb-h text-right text-right'></td>
	          </tr>
              <tr style={{display:(itemlist.summary.sum3?'':'none')}}>
                <td className='text-center bt-h br-h bb-h'></td>
	          	<td className='bt-h br-h bb-h'>ค่าอะไหล่ <span style={{float:'right'}}>{this.getNumberFormat(this.getSummaryAmount())}</span></td>
	            <td className='bt-h br-h bb-h'></td>
                <td className='bt-h br-h bb-h text-right'></td>
                <td className='bt-h br-h bb-h text-right'></td>
                <td className='bt-h br-h bb-h text-right'></td>
	            <td className='bt-h bb-h text-right text-right'></td>
	          </tr>
              <tr style={{display:(itemlist.summary.sum4?'':'none')}}>
                <td className='text-center bt-h br-h bb-h'></td>
	          	<td className='bt-h br-h bb-h'>รวมค่าสินค้า</td>
	            <td className='bt-h br-h bb-h'></td>
                <td className='bt-h br-h bb-h text-right'></td>
                <td className='bt-h br-h bb-h text-right'></td>
                <td className='bt-h br-h bb-h text-right'></td>
	            <td className='bt-h bb-h text-right text-right'>{this.getNumberFormat(this.getSummaryAmount())}</td>
	          </tr>
              <tr style={{display:(itemlist.summary.sum5?'':'none')}}>
                <td className='text-center bt-h br-h bb-h'></td>
	          	<td className='bt-h br-h bb-h'>บวก-ภาษีมูลค่าเพิ่ม <span style={{float:'right'}}>7%</span></td>
	            <td className='bt-h br-h bb-h'></td>
                <td className='bt-h br-h bb-h text-right'></td>
                <td className='bt-h br-h bb-h text-right'></td>
                <td className='bt-h br-h bb-h text-right'></td>
	            <td className='bt-h bb-h text-right text-right'>{this.getNumberFormat(this.getVat())}</td>
	          </tr>
	          <tr>
	          	<td style={{verticalAlign:'middle'}} className='text-center br-h' colSpan={4}>{(itemlist.summary.sum5?(data.grand_total_thai===''||data.grand_total_thai===null||data.grand_total_thai===undefined?'( ศูนย์บาทถ้วน )':'( '+data.grand_total_thai+' )'):'')}</td>
	            <td className='text-center br-h' colSpan={2}>รวมเงิน<br/>TOTAL AMOUNT</td>
	            <td style={{verticalAlign:'middle'}} className='text-right'>{itemlist.summary.sum5?this.getNumberFormat(data.amount):''}</td>
	          </tr>
	        </tbody>
	    </table>
      </div>    
  	)
  }

  renderRowData(itemlist,itemIndex) {
  	let {data} = this.state
  	return(
        itemlist.data.map((item,index)=>{
  			return(
  				<tr key={index}>
  					<td className={'text-center br-h bb-h '+(index>0?'bt-h':'')}>{item.seq===''?<br/>:index+1}</td>
  					<td className={index>0?'bt-h br-h bb-h':'br-h bb-h'}>{item.seq===''?'':item.detail}</td>
  					<td className={'text-center br-h bb-h '+(index>0?'bt-h':'')}>{item.seq===''||item.quantity==='0'||item.quantity===''?'':this.getNumberFormat(item.quantity)}</td>
  					<td className={'text-right br-h bb-h '+(index>0?'bt-h':'')}>{item.seq===''||item.quantity==='0'||item.quantity===''?'':this.getNumberFormat(item.price_per_unit)}</td>
  					<td className={'text-right br-h bb-h '+(index>0?'bt-h':'')}>{item.seq===''||item.quantity==='0'||item.quantity===''?'':this.getNumberFormat(this.getDiscountPercent(item.discount,item.amount))}</td>
  					<td className={'text-right br-h bb-h '+(index>0?'bt-h':'')}>{item.seq===''||item.quantity==='0'||item.quantity===''?'':this.getNumberFormat(item.amount-item.discount)}</td>
  					<td className={'text-right bb-h '+(index>0?'bt-h':'')}>{item.seq===''||item.quantity==='0'||item.quantity===''?'':this.getNumberFormat(item.amount)}</td>
  				</tr>
  			)
  		})
  	)
  }

  renderComponentPage(itemlist,itemIndex) {
    let {data,defaultTypePrint} = this.state
    return(
      <div className='font-print print-ssr-general-doc' key={itemIndex}>
        <div>
	        <header>
	          <h2 className="text-right">{this.props.title}</h2>
	          <br/>
	          <div>(เอกสารออกเป็นชุด)</div>
	        </header>  
	        <article className={"article-company "+data.logo_class}>
	          <div style={{width:data.logo_width+'px',textAlign:'center',lineHeight:'70px'}}>
	            {this.renderLogoUrl(data.logo_url)}
	          </div>
	          <section className="font-16" style={{width:'85%',paddingTop:(data.logo_class=='bg-logo-absolute'?'0px':'0')}}>
	            <strong>
	              <p style={{lineHeight:'0.7'}}>{data.company_name} (สำนักงานใหญ่)</p>           
	              <p style={{lineHeight:'0.7'}}>{data.company_addr} </p>
	              <p style={{lineHeight:'0.7'}}>เลขประจำตัวผู้เสียภาษีอากร {data.company_tax} โทร {data.company_tel}</p>              
	            </strong>
	          </section>
	          <section className='text-right sec-copy-doc'>
              <span style={{display:defaultTypePrint=='0'?'none':''}}>{itemlist.type=='ori'?'ต้นฉบับ':itemlist.type=='copy'?'สำเนา':''}</span>  
              <p style={{display:data.deleted==='1'?'':'none'}} className='p-copy-doc'>ยกเลิก</p>
  		      </section>
	        </article>
	        {this.renderBody(itemlist.data,itemIndex)}
	      </div>
      </div>  
    )
  }

  onTypePrintChange(e) {
  	this.setState({defaultTypePrint:e})  
  }

  getPagination(data) {
    let checkRow = 0
    let newData = []
    let allData = []
    let summary = {sum:false,sum1:false,sum2:false,sum3:false,sum4:false,sum5:false}
      
    data.forEach((item,index)=>{
      if (checkRow<DEFAUT_ROW) {
        newData.push(item)
      }
      if (checkRow==DEFAUT_ROW-1||index==data.length-1) {
        allData.push({
          data:newData,
          summary:summary
        })
        newData = []
        checkRow = -1
      }
      checkRow++
    })
    
    if (allData.length>0) {
        if (DEFAUT_ROW-allData[allData.length-1].data.length>=6) {
            allData[allData.length-1].data = allData[allData.length-1].data.concat(this.newEmptyRow(DEFAUT_ROW-(allData[allData.length-1].data.length+6)))
            allData[allData.length-1].summary = {sum:true,sum1:true,sum2:true,sum3:true,sum4:true,sum5:true}
        } else if (DEFAUT_ROW-allData[allData.length-1].data.length>4&&DEFAUT_ROW-allData[allData.length-1].data.length<=5) {
            allData[allData.length-1].summary = {sum:true,sum1:true,sum2:true,sum3:true,sum4:true,sum5:false}
            allData.push({
                data:this.newEmptyRow(DEFAUT_ROW-1),
                summary:{sum:false,sum1:false,sum2:false,sum3:false,sum4:false,sum5:true}
            })
        } else if (DEFAUT_ROW-allData[allData.length-1].data.length>3&&DEFAUT_ROW-allData[allData.length-1].data.length<=4) {
            allData[allData.length-1].summary = {sum:true,sum1:true,sum2:true,sum3:true,sum4:false,sum5:false}
            allData.push({
                data:this.newEmptyRow(DEFAUT_ROW-2),
                summary:{sum:false,sum1:false,sum2:false,sum3:false,sum4:true,sum5:true}
            })
        } else if (DEFAUT_ROW-allData[allData.length-1].data.length>2&&DEFAUT_ROW-allData[allData.length-1].data.length<=3) {
            allData[allData.length-1].summary = {sum:true,sum1:true,sum2:true,sum3:false,sum4:false,sum5:false}
            allData.push({
                data:this.newEmptyRow(DEFAUT_ROW-3),
                summary:{sum:false,sum1:false,sum2:false,sum3:true,sum4:true,sum5:true}
            })
        } else if (DEFAUT_ROW-allData[allData.length-1].data.length>1&&DEFAUT_ROW-allData[allData.length-1].data.length<=2) {
            allData[allData.length-1].summary = {sum:true,sum1:true,sum2:false,sum3:false,sum4:false,sum5:false}
            allData.push({
                data:this.newEmptyRow(DEFAUT_ROW-4),
                summary:{sum:false,sum1:false,sum2:true,sum3:true,sum4:true,sum5:true}
            })
        } else if (DEFAUT_ROW-allData[allData.length-1].data.length>0&&DEFAUT_ROW-allData[allData.length-1].data.length<=1) {
            allData[allData.length-1].summary = {sum:true,sum1:false,sum2:false,sum3:false,sum4:false,sum5:false}
            allData.push({
                data:this.newEmptyRow(DEFAUT_ROW-5),
                summary:{sum:false,sum1:true,sum2:true,sum3:true,sum4:true,sum5:true}
            })
        } else if (DEFAUT_ROW-allData[allData.length-1].data.length<=0) {
            allData.push({
                data:this.newEmptyRow(DEFAUT_ROW-6),
                summary:{sum:true,sum1:true,sum2:true,sum3:true,sum4:true,sum5:true}
            })
        }    
    }    
    
    return allData
  }
  
  renderNoData() {
    return(
      <div className='font-print'>
        <header className="text-center">
          <h2>{this.state.report_title}</h2>
        </header>
      </div>
    )
  }

  setPageRender(dataList,defaultTypePrint) {
    let pages = []
    dataList.forEach((item,index)=>{
        if (defaultTypePrint=='1'||defaultTypePrint=='3'||defaultTypePrint=='0') {
            pages.push({
                page:index+1,
                type:'ori',
                data:item
            })
        } else if (defaultTypePrint=='2') {
            pages.push({
                page:index+1,
                type:'copy',
                data:item
            })
        }
    })
    if (defaultTypePrint=='3'||defaultTypePrint=='0') {
        pages.forEach((item,index)=>{
            pages.push({
                page:pages[pages.length-1].page+1,
                type:'copy',
                data:item.data
            })
        })
    }
    return pages
  }

  render() {
    let {loading,dataList,defaultTypePrint} = this.state
    let pages = this.setPageRender(dataList,defaultTypePrint)
    
    if (dataList.length==0) {
        return(
          <PrintPreview
            loading={loading}
            leftBarTitle={this.props.title}
          >  
            {this.renderNoData()}
          </PrintPreview>  
        )
      } else {
        return(
            <div>
                <PrintPreview
                    loading={loading}
                    leftBarTitle={this.props.title}
                    onTypePrintChange={this.onTypePrintChange.bind(this)}
                    defaultTypePrint={this.state.defaultTypePrint}
                    showPageNumber={false}
                >
                    {
                    pages.map((item,index) => {
                        return(
                        this.renderComponentPage(item,index)
                        )
                    }) 
                    }
                </PrintPreview>
                <NotificationSystem ref="notificationSystem" />
            </div>
            ) 
        }
    }    
}  

PrintSSRGeneralDoc.defaultProps = {
  title: 'สำหรับลูกค้า',  
  mode: '1'
}
export default PrintSSRGeneralDoc;


// WEBPACK FOOTER //
// ./src/view/print/ssr/PrintSSRGeneralDoc.js